import React from "react";
import Skeleton from "@mui/material/Skeleton";
import { Box } from "@mui/material";

export default function SkelectonCard() {
  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Box
        sx={{
          alignItems: "flex-end",
          display: "flex",
          height: "2rem",
          flexDirection: "column",
        }}
      >
        <Skeleton sx={{ width: "80%" }} variant="text" />
        <Skeleton sx={{ width: "80%" }} variant="text" />
      </Box>
    </Box>
  );
}
